import { SwitchInput, TextInput } from 'corso-admin-ui';
import { CrewIncentiveTypeEnum, toEnum } from 'corso-types';
import { Controller } from 'react-hook-form';
import MonetaryRateInput, {
  MonetaryType,
} from '~/components/field/MonetaryRateInput';
import { useAutomationFormContext } from '~/features/settings/automations/hooks/useAutomationForm';
import { useCurrency } from '~/hooks/useCurrency';

export default function EventApplyLineItemFee() {
  const { control, watch, setValue, getFieldState } =
    useAutomationFormContext();

  const { currencyCode, currencySymbol } = useCurrency();

  const feeAmount = watch('event.params.feeAmount');
  const incentiveType = watch('event.params.feeType');
  const applyPerItem = watch('event.params.applyPerItem');

  return (
    <>
      <Controller
        control={control}
        name="event.params.feeDisplayName"
        render={({ field, fieldState }) => (
          <TextInput
            id="line-item-fee-display-name"
            label="Display Name"
            details="The name of the fee, this will be shown to the customer."
            required
            {...field}
            error={fieldState.error?.message}
          />
        )}
      />
      <MonetaryRateInput
        id="fee-amount"
        label="Fee Amount"
        labelVisuallyHidden
        details="The amount to apply as a fee, Percent based fees are calculated on the value of the claimed items."
        required
        defaultValue={1}
        currencyCode={currencyCode}
        currencySymbol={currencySymbol}
        value={{
          type:
            incentiveType === CrewIncentiveTypeEnum.none
              ? CrewIncentiveTypeEnum.fixed
              : toEnum(incentiveType, MonetaryType),
          amount: feeAmount,
        }}
        onChange={({ type, amount }) => {
          setValue('event.params.feeAmount', amount, {
            shouldDirty: true,
            shouldValidate: true,
            shouldTouch: true,
          });
          setValue('event.params.feeType', type, {
            shouldDirty: true,
            shouldValidate: true,
            shouldTouch: true,
          });
          // per-item charging only applies to fixed fees
          if (type !== MonetaryType.fixed) {
            setValue('event.params.applyPerItem', false, {
              shouldDirty: true,
              shouldValidate: true,
              shouldTouch: true,
            });
          }
        }}
        error={
          getFieldState('event.params.feeAmount').error?.message ??
          getFieldState('event.params.feeType').error?.message
        }
      />

      {incentiveType === CrewIncentiveTypeEnum.fixed && (
        <SwitchInput
          id="apply-per-item-switch"
          label="Charge Per Quantity of Item"
          details="Charge the fee for each individual quantity of a matched line item."
          checked={applyPerItem}
          onChange={(e) => {
            setValue('event.params.applyPerItem', e.target.checked, {
              shouldDirty: true,
              shouldValidate: true,
              shouldTouch: true,
            });
          }}
        />
      )}
    </>
  );
}
